import React from 'react';
import { CellProps } from 'react-table';

import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/provider-actions.module.scss';
import { IProvider } from 'src/types/provider';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';

const ProviderActionsColumn: React.FunctionComponent<CellProps<IProvider>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IProvider>) => {
    if (!user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        return (
            <div className={classNames(styles.actions)}>
                <Link to={Router.generate(routes.PROVIDER_DETAIL, { id: original.id, tab: 'calendar', subId: '' })}>
                    {original.fullName}
                </Link>
            </div>
        );
    }
    return (
        <div className={classNames(styles.actions)}>
            <Link to={Router.generate(routes.PROVIDER_DETAIL, { id: original.id, tab: 'main-info', subId: '' })}>
                {original.fullName}
            </Link>
        </div>
    );
};

export default ProviderActionsColumn;
